'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallShare = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("g", {
                    clipPath: "url(#clip0_5093_12268)",
                    children: jsxRuntime.jsx("path", {
                        d: "M13.3398 5.33001L7.7598 0.55001C7.4498 0.28001 6.9998 0.22001 6.6398 0.40001C6.2698 0.57001 6.0298 0.95001 6.0298 1.36001V3.08001C4.3398 3.46001 2.9898 4.30001 2.0098 5.58001C0.599805 7.42001 0.299805 9.74001 0.299805 11.36C0.299805 12.15 0.369805 12.7 0.389805 12.8C0.459805 13.28 0.839805 13.65 1.3298 13.7C1.3698 13.7 1.3998 13.7 1.4398 13.7C1.8798 13.7 2.2798 13.43 2.4298 13C3.3398 10.52 4.9398 9.71001 6.0298 9.45001V10.91C6.0298 11.32 6.2698 11.7 6.6398 11.87C7.0098 12.04 7.4498 11.98 7.7698 11.71L13.3398 6.93001C13.5698 6.73001 13.6998 6.44001 13.6998 6.12001C13.6998 5.80001 13.5698 5.51001 13.3398 5.32001V5.33001Z",
                        fill: "currentColor"
                    })
                }),
                jsxRuntime.jsx("defs", {
                    children: jsxRuntime.jsx("clipPath", {
                        id: "clip0_5093_12268",
                        children: jsxRuntime.jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("g", {
                    clipPath: "url(#clip0_5093_12261)",
                    children: jsxRuntime.jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1.76524 12.7653C3.07285 9.17779 5.77723 8.70192 6.72486 8.64844V10.9105C6.72486 11.0497 6.80509 11.1759 6.93126 11.2349C7.05674 11.2932 7.20417 11.2726 7.30976 11.1828L12.8817 6.40622C13.0394 6.27045 13.0394 5.99686 12.8817 5.86177L7.30976 1.08522C7.20417 0.995399 7.05674 0.974142 6.93126 1.03311C6.80509 1.0914 6.72486 1.21756 6.72486 1.35745V3.65521C4.93863 3.92949 3.53913 4.71666 2.5627 5.99823C1.24274 7.73098 1 9.95537 1 11.3549C1 12.1194 1.07268 12.6371 1.08091 12.6947C1.10491 12.8559 1.23451 12.9807 1.39565 12.9978C1.55747 13.0143 1.70969 12.9189 1.76524 12.7653Z",
                        stroke: "currentColor",
                        strokeWidth: "1.4",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                }),
                jsxRuntime.jsx("defs", {
                    children: jsxRuntime.jsx("clipPath", {
                        id: "clip0_5093_12261",
                        children: jsxRuntime.jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

module.exports = SmallShare;
